module.exports = __webpack_public_path__ + "static/media/17@720w.99101951.jpg";